import React from "react";

type Props = {
  stepNumber?: number | string;
  title?: string;
  paragraphs?: string[];
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  textClassName?: string;
  actionsClassName?: string;
};

const StepIntroBubble = ({
  stepNumber,
  title,
  paragraphs = [],
  children,
  actions,
  className = "v2oa-code-block",
  textClassName = "v2oa-text",
  actionsClassName = "v2oa-actions",
}: Props) => {
  return (
    <div className={className}>
      {title ? (
        <div className="v2oa-step-title">
          {stepNumber !== undefined ? <span>{stepNumber}</span> : null}
          {title}
        </div>
      ) : null}

      {paragraphs.map((text, idx) => (
        <div key={`${idx}-${text.slice(0, 16)}`} className={textClassName}>
          {text}
        </div>
      ))}

      {children}

      {actions ? <div className={actionsClassName}>{actions}</div> : null}
    </div>
  );
};

export default StepIntroBubble;
